import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
const filter = createFilterOptions();
let debounce;
const BrandAutocomplete = ({ authorize = true, onSelect, defaultValue, errorMessage, apiService }) => {
    const [value, setValue] = React.useState(defaultValue);
    const [isLoading, setIsLoading] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [isBusy, setIsBusy] = React.useState(false);
    const [createError, setCreateError] = React.useState("");
    const fetchResults = (searchTerm) => {
        if (searchTerm.length < 2)
            return;
        apiService.get('/brands?params=' + JSON.stringify({ filters: { name: searchTerm } }))
            .then(res => {
            setIsLoading(false);
            setOptions(res.data.brands);
        })
            .catch((error) => {
            setIsLoading(false);
            console.log("error in fetch results", error);
        });
    };
    const onInputChange = (e, value, reason) => {
        if (reason === "reset" || !value)
            return;
        setIsLoading(true);
        if (debounce)
            clearTimeout(debounce);
        debounce = setTimeout(() => {
            fetchResults(value);
        }, 500);
    };
    const createNewBrand = (newBrandName) => {
        setIsBusy(true);
        apiService.post("/brands", { name: newBrandName })
            .then(res => {
            setValue(res.data);
            onSelect(res.data);
            setIsBusy(false);
        })
            .catch(err => {
            if (authorize && err.response.status === 401) {
                setCreateError("Failed to create brand. Try again.");
            }
            else {
                onSelect({ name: newBrandName });
            }
            setIsBusy(false);
        });
    };
    return (_jsx(Autocomplete, { value: value, size: 'small', loading: isLoading, onInputChange: onInputChange, onChange: (event, newValue) => {
            if (typeof newValue === 'string') {
                //setValue({ name: newValue });
            }
            else if (newValue && newValue.inputValue) {
                //setValue({name: newValue.inputValue})
                createNewBrand(newValue.inputValue);
            }
            else {
                setValue(newValue);
                onSelect(newValue);
            }
        }, filterOptions: (options, params) => {
            const filtered = filter(options, params);
            const { inputValue } = params;
            // Suggest the creation of a new value
            const isExisting = options.some((option) => inputValue === option.name);
            if (inputValue !== '' && filtered.length < 1 && !isLoading && !isExisting) {
                filtered.push({
                    inputValue,
                    name: `Add "${inputValue}"`,
                });
            }
            return filtered;
        }, selectOnFocus: true, clearOnBlur: true, handleHomeEndKeys: true, id: "free-solo-with-text-demo", options: options, getOptionLabel: (option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
                return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
                return option.inputValue;
            }
            // Regular option
            return option.name;
        }, renderOption: (props, option) => _jsx("li", Object.assign({}, props, { children: option.name })), freeSolo: true, renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { placeholder: "Search Brand", variant: "outlined", sx: {
                '&.MuiAutocomplete-inputRoot': { padding: '5.5px 4px 7.5px 6px' },
            }, error: Boolean(errorMessage || createError), helperText: errorMessage || createError, InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [isBusy ? _jsx(CircularProgress, { color: "inherit", size: 20 }) : null, params.InputProps.endAdornment] })) }) }))) }));
};
export default BrandAutocomplete;
